import dayjs from 'dayjs';
import React from 'react';
import styled from 'styled-components';
import { images } from '../../assets/images';
import { SizedBox } from './SizedBox';
import { Description, H4 } from './Styles';

type Props = {
  authorLabel?: string;
  author: string;
  subtitleDateLabel?: string;
  subtitleDate: string;
  authorImage?: string;
  /** mini: no date, normal: author and date */
  mode?: 'normal' | 'mini';
};

export const RhAuthorInfo = (props: Props) => {
  const {
    authorLabel = 'Created by:',
    subtitleDateLabel = 'LAST MODIFIED:',
    mode = 'normal',
  } = props;
  return (
    <Container>
      <AuthorImage small={props.mode === 'mini'} src={props.authorImage || images.fallbackImage} />
      <div>
        <Description weight="400">
          {authorLabel} <b>{props.author}</b>
        </Description>
        {mode === 'normal' && (
          <>
            <SizedBox height={2} />
            <H4 up>
              {subtitleDateLabel} {dayjs(props.subtitleDate).format('ddd, MMM DD, YYYY | hh:mmA')}
            </H4>
          </>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
`;

const AuthorImage = styled.img<{ small?: boolean }>`
  object-fit: cover;
  width: ${({ small = false }) => (small ? 24 : 42)}px;
  height: ${({ small = false }) => (small ? 24 : 42)}px;
  margin-right: ${({ small = false }) => (small ? 8 : 14)}px;
  border-radius: 21px;
`;
